import { Injectable } from '@angular/core';
import { CatalogService } from './catalog.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ComplaintService {

    constructor(private readonly catalogService: CatalogService,) { }

    transformData(data){
        data.createdAt = new Date(data.createdAt);
        return data;
    }

    getComplaints(params?) {
        console.log('params: ', params);

        return this.catalogService.getByNameWithParams(`complaints`, params).pipe(
            map((response) => {
                if (!response || typeof response !== 'object') {
                    return {
                        pagination: {
                            search: '',
                            page: 1,
                            limit: 0,
                            totalRecords: 0,
                            totalPages: 1
                        },
                        data: []
                    };
                }
                const meta = response.meta || {};
                let filters = {};
                if (meta.filter) {
                    filters = Object.assign({}, ...Object.keys(meta.filter).map(key => {
                        return { [`filter.${key}`]: meta.filter[key] };
                    }));
                }
                return {
                    pagination: {
                        search: meta.search && meta.search !== 'undefined' ? meta.search : '',
                        page: meta.currentPage || 1,
                        limit: meta.itemsPerPage || 0,
                        totalRecords: meta.totalItems || 0,
                        totalPages: meta.totalPages || (meta.totalItems ? Math.ceil(meta.totalItems / (meta.itemsPerPage || 1)) : 1),
                        ...filters
                    },
                    data: Array.isArray(response.data) ? response.data.map(complaint => this.transformData(complaint)) : []
                }
            })
        );
    }

    getComplaint(id){
      return this.catalogService.getOneByName(`complaints/${id}`).pipe(
          map(({data}) => this.transformData(data))
      );
    }

    deleteComplaint(id: number) {
      return this.catalogService.deleteOfURL(`complaints/${id}`);
    }

    restoreComplaint(id: number) {
      return this.catalogService.putOfURL(`complaints/${id}/restore`);
    }
}
